import styled from 'styled-components'

export const StyledButton = styled.button<{
  disabled?: boolean
  $outlined?: boolean
}>`
  padding: 12px 24px;
  border: none;
  font-family: ${({ theme }) => theme.typography.family.Poppins};
  background-color: ${p => (p.$outlined ? 'transparent' : p.theme.colors.button.background)};
  border-radius: 100px;
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  color: ${p => (p.$outlined ? p.theme.colors.text.primary : p.theme.colors.button.text)};
  font-size: ${p => p.theme.typography.size.Description}px;
  font-weight: ${p => p.theme.typography.weight.Medium};
  border: ${p => (p.$outlined ? `1px solid ${p.theme.colors.text.primary}` : 'none')};
  opacity: ${p => (p.disabled ? '0.5' : 1)};
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    ${p => !p.disabled && !p.$outlined && `background-color: ${p.theme.colors.button.hover};`}
    ${p =>
      !p.disabled &&
      p.$outlined &&
      `box-shadow: 0 4px 10px ${p.theme.colors.button.outlinedBoxShadow};`}
  }

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    padding: 8px 16px;
    font-size: ${p => p.theme.typography.size.Caption1}px;
  }
`
